export enum DocumentStatus {
  Denied = 1,
}
